import { getAuthedDataClient, getCatalogClient } from '@/lib/amplify-client';

export type SlugEntityType = 'product' | 'vendor' | 'solar';

export async function resolveSlugRedirect(
  oldSlug: string,
  entityType: SlugEntityType,
): Promise<string | undefined> {
  const normalized = oldSlug.trim().toLowerCase();
  if (!normalized) return undefined;
  try {
    const client = await getCatalogClient();
    const res = await client.models.SlugRedirect.list({
      filter: {
        oldSlug: { eq: normalized },
        entityType: { eq: entityType },
      },
      limit: 1,
    });
    const row = (res.data ?? [])[0] as { newSlug?: string } | undefined;
    return row?.newSlug ? String(row.newSlug) : undefined;
  } catch {
    return undefined;
  }
}

/** Record a permanent slug change (best-effort; requires authenticated create on SlugRedirect). */
export async function recordSlugRedirect(
  oldSlug: string,
  newSlug: string,
  entityType: SlugEntityType,
): Promise<void> {
  const oldNorm = oldSlug.trim().toLowerCase();
  const newNorm = newSlug.trim().toLowerCase();
  if (!oldNorm || !newNorm || oldNorm === newNorm) return;
  try {
    const client = await getAuthedDataClient();
    await client.models.SlugRedirect.create({
      oldSlug: oldNorm,
      newSlug: newNorm,
      entityType,
    });
  } catch (e) {
    console.warn('[ShopGND] recordSlugRedirect failed', e);
  }
}
